import { ExportFormHook } from '@app/modules/social-export/hooks/useSocialExportFactory';
import { socialExport } from '@mi-front/api-clients';
import { InstagramPublishForm } from './InstagramPublishForm';
import { InstagramSettingsForm } from './InstagramSettingsForm';

export const useInstagramExport: ExportFormHook<
  socialExport.InstagramPublishDto,
  socialExport.InstagramSettingsDto
> = () => {
  return {
    PublishForm: InstagramPublishForm,
    SettingsForm: InstagramSettingsForm,
  };
};
